import React, {createContext, useContext} from 'react';

const ViewOnlyModeContext = createContext(false);

export const ViewOnlyModeProvider = ({children, viewOnlyMode = false}) => (
  <ViewOnlyModeContext.Provider value={viewOnlyMode}>{children}</ViewOnlyModeContext.Provider>
);

export const useViewOnlyMode = () => useContext(ViewOnlyModeContext);
